import styled, { css } from 'styled-components';
import { space, color, font, query } from '@design/templateFns';
import Block from '@components/Layout/Block';

export const StyledBlock = styled(Block)`
  > div {
    overflow: visible;
  }
`;

export const HeroWrapper = styled.div`
  position: relative;
  overflow: initial;
`;

// SEARCH BAR

export const SearchWrapper = styled.div`
  margin-bottom: ${space('x7')};
  padding-left: ${space('marginMobile')};
  padding-right: ${space('marginMobile')};
  position: relative;

  @media screen and (${query.atLeast('tablet')}) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
    width: 100%;
    max-width: 460px;
  }

  @media screen and (${query.atLeast('max')}) {
    max-width: 560px;
  }
`;

export const SearchInputInner = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr max-content;
  width: 100%;
  z-index: 40;
`;

export const SearchButton = styled.button`
  background-color: ${color('cta')};
  cursor: pointer;
  height: inherit;
  border: none;
  margin: 0;
  border-radius: 0 4px 4px 0;
  padding: ${space('sm')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s ease-in-out;

  @media screen and (${query.atLeast('tablet')}) {
    padding: ${space('sm')} ${space('md')};
  }

  svg {
    width: ${space('xl')};
    height: ${space('xl')};
  }

  &:hover {
    background-color: ${color('warning')};
  }
`;

// AUTOCOMPLETE
export const AutocompleteWrapper = styled.div`
  background: #fff;
  border-radius: 0 0 4px 4px;
  position: absolute;
  width: 100%;

  box-sizing: border-box;
  top: 100%;

  li {
    list-style-type: none;
  }
`;

export const AutocompleteSection = styled.ul<{
  $noBorder?: boolean;
  $header?: string;
}>`
  padding: 0;
  margin: 0;
  border-top: ${({ $noBorder }) => (!$noBorder ? '1px solid #d4d4d4' : 'none')};
  color: #242323;
  padding: ${space('md')} 0;
  position: relative;
  z-index: 99;

  ${font('body-md-light')}

  ${({ $header }) =>
    $header &&
    css`
      &:before {
        content: '${$header}';
        background: #fff;
        padding: 0 ${space('md')};
        position: absolute;
        top: -12px;
        left: 0;
        color: #757575;
      }
    `}
`;

export const AutocompleteItem = styled.li`
  border: none;
  cursor: pointer;
  padding: ${space('sm')} ${space('md')};

  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  grid-gap: 8px;

  &:hover {
    background-color: #f4f4f4;
  }
`;
export const AutocompleteItemIcon = styled.span`
  width: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const AutocompleteItemText = styled.span`
  flex-grow: 1;
`;

// BUY RENT TAB
export const BuyRentWrapper = styled.div`
  overflow: hidden;
  text-align: center;
  ${font('eyebrow-sm')}
  margin-top: ${space('x6')};

  @media screen and (${query.atLeast('tablet')}) {
    border: none;
  }
`;

export const BuyRentInnerWrapper = styled.div`
  background-color: #757575;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  display: inline-block;

  @media screen and (${query.atLeast('tablet')}) {
    border: none;
  }
`;

export const TabButton = styled.button<{ $active?: boolean; $left?: boolean }>`
  ${font('eyebrow-sm')};
  border: none;
  text-transform: uppercase;
  text-decoration: none;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  letter-spacing: 0.1em;
  padding: 7px ${space('md')};

  ${({ $active, $left }) =>
    $active &&
    css`
      background-color: #f4f4f4;
      color: #4b4b4b;
      border-radius: 4px;
      height: 36px;
      @media screen and (${query.atLeast('tablet')}) {
        border-radius: 4px;
      }
    `}
`;
